import { createAction } from 'redux-actions';
import { CommissionStatusType } from '@wix/da-shared-react/pkg/types/commissions';

export const changeAllCommissionsStatus = createAction(
  'COMMISSION.CHANGE_ALL_COMMISSIONS_STATUS',
  (status: CommissionStatusType) => ({ status })
);
